module.exports = __webpack_public_path__ + "img/icon-connected-server.8dcc623c.svg";